import React, { memo } from 'react'
import GMap from '../../GMap'
import newIcon from '../../../Assets/Images/icons/new_location_icon.svg'

const CityMap = memo(props => {
  const { cityLocation } = props
  const onMapInit = map => {
    if (!map) return
    map.addListener('center_changed', () => onMapChange(map))
  }

  const onMapChange = map => {
    props.editCityLocation({
      latitude: map.getCenter().lat(),
      longitude: map.getCenter().lng(),
    })
  }

  return (
    <section>
      <div style={{ position: 'relative' }}>
        <GMap
          onInit={map => {
            onMapInit(map)
          }}
          mapSettings={{
            center: {
              lat: cityLocation ? cityLocation.latitude : 0,
              lng: cityLocation ? cityLocation.longitude : 0,
            },
            zoom: 6,
          }}
        />
        <div
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
          }}
        >
          <img
            src={newIcon}
            alt="City Center"
            style={{
              width: 30,
              height: 42,
              position: 'relative',
              top: -21,
            }}
          />
          <div />
        </div>
      </div>
    </section>
  )
})

export { CityMap }
